import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IdentityState, identityFeatureKey } from './identity.state';


export const getIdentityState = createFeatureSelector<IdentityState>(identityFeatureKey);

export const getUserProfile = createSelector(getIdentityState, (state) => state.userProfile);
export const getSendOtp = createSelector(getIdentityState, (state) => state.sendOtp);
export const getRedeemOtpStatus = createSelector(getIdentityState, (state) => state.isValidOtp);
